<template>
    <div
        class="relative cursor-default"
        v-resize="updateOverflowTag"
    >
        <TransitionGroup
            name="tags"
            tag="div"
            class="tags"
            :class="{
                'flex-wrap': outsideTagIndex === undefined,
                'overflow-hidden overflow-y-auto': limitedHeight,
            }"
            :style="{
                maxHeight: limitedHeight ? '100px' : ''
            }"
        >
            <template v-for="(tag) in tempTags" :key="tag?.id">
                <slot name="tag" :tag="tag">
                    <v-tag :tag="tag" @click.stop>
                        <template #left-icon>
                            <slot name="tag-left-icon"></slot>
                        </template>
                        <template #right-icon>
                            <slot name="tag-right-icon"></slot>
                        </template>
                    </v-tag>
                </slot>
            </template>
            <slot
                name="more-tag"
                :tag="tag"
                :toggleMore="toggleMore"
                v-if="outsideTagIndex !== null"
            >
                <v-tag
                    @click.stop="toggleMore"
                    :tag="{
                        name: outsideTagIndex === undefined ? 'hide' : `+ ${hiddenTagsCount}`,
                        classes: 'cursor-pointer hide-tag-btn !transform-none !transition-none'
                    }"
                >
                    <template #left-icon>
                        <slot name="more-tag-left-icon"></slot>
                    </template>
                    <template #right-icon>
                        <slot name="more-tag-right-icon"></slot>
                    </template>
                </v-tag>
            </slot>
        </TransitionGroup>

        <div
            class="tags !h-0 overflow-hidden pointer-events-none opacity-0"
            :class="{
                'flex-wrap': outsideTagIndex === undefined
            }"
            ref="items"
        >
            <template v-for="(tag) in tags" :key="tag?.id">
                <slot
                    name="tag"
                    :tag="{
                        ...tag,
                        classes: (i >= outsideTagIndex && outsideTagIndex != null) ? 'hidden-tag' : '',
                    }"
                >
                    <v-tag
                        :tag="{
                            ...tag,
                            classes: (i >= outsideTagIndex && outsideTagIndex != null) ? 'hidden-tag' : '',
                        }"
                    >
                        <template #left-icon>
                            <slot name="tag-left-icon"></slot>
                        </template>
                        <template #right-icon>
                            <slot name="tag-right-icon"></slot>
                        </template>
                    </v-tag>
                </slot>
            </template>
            <slot
                name="more-tag"
                :tag="tag"
                :toggleMore="toggleMore"
                v-if="outsideTagIndex !== null"
            >
                <v-tag
                    @click="toggleMore"
                    :tag="{
                        name: outsideTagIndex === undefined ? 'hide' : `+ ${hiddenTagsCount}`,
                        classes: `cursor-pointer hide-tag-btn !transform-none !transition-none ${(outsideTagIndex === null) ? 'hidden-tag' : ''}`,
                    }"
                >
                    <template #left-icon>
                        <slot name="more-tag-left-icon"></slot>
                    </template>
                    <template #right-icon>
                        <slot name="more-tag-right-icon"></slot>
                    </template>
                </v-tag>
            </slot>
        </div>
    </div>
</template>

<script>

export default {
    name: 'v-tags',
    props: {
        tags: {
            type: Array,
            required: true,
        },
        limitedHeight: {
            type: Boolean,
            defualt: false,
        },
    },
    watch: {
        tags: {
            handler(arr) {
                this.tempTags = arr;
                // if (this.outsideTagIndex === null)
                this.updateOverflowTag();
            },
            deep: true,
        }
    },
    data() {
        return {
            outsideTagIndex: null,
            tempTags: this.tags,
            // componentId: null,
        }
    },
    methods: {
        toggleMore() {
            this.outsideTagIndex = this.outsideTagIndex === undefined ? null : undefined;
            this.tempTags = this.tags?.slice?.(0, this.outsideTagIndex);

            // if (this.outsideTagIndex === null)
            this.updateOverflowTag();
        },
        getContainerGap() {
            if (!this.$refs?.items?.$el && !this.$refs?.items) return false;
            return Number(
                window?.getComputedStyle?.(
                    this.$refs?.items?.$el ?? this.$refs?.items
                )?.gap?.replace?.(/\D/g, '')
            );
        },
        updateOverflowTag() {
            if (this.outsideTagIndex === undefined) return;

            const container = this.$refs.items?.$el ?? this.$refs.items;
            const _items = container?.children ?? 0;

            const containerWidth = container?.clientWidth ?? 0;
            const gap = this.getContainerGap() | 8;
            const overflowTagWidth = _items[_items.length - 1]?.offsetWidth ?? 0;

            let totalWidth = 0;

            for (let i = 0; i < _items.length - 1; i++) {
                const tag = _items?.[i];
                if (totalWidth + (tag?.offsetWidth ?? 0) + gap + overflowTagWidth < containerWidth) {
                    totalWidth += (tag?.offsetWidth ?? 0) + gap;
                } else {
                    this.outsideTagIndex = i;
                    this.tempTags = this.tags?.slice?.(0, this.outsideTagIndex);
                    return;
                }
            }
            this.tempTags = this.tags;

            this.outsideTagIndex = null;
        },
    },
    computed: {
        hiddenTagsCount() {
            return this.tags?.length - this.outsideTagIndex;
        },
        items() {
            const arr = [];
            let specialTag, tashimedTag;
            this.tags?.forEach?.(tag => {
                if (tag?.name == 'Специальное') {
                    specialTag = tag;
                } else if (tag?.label == 'TASHIMED') {
                    tashimedTag = tag;
                } else {
                    arr.push(tag)
                }
            });
            if (specialTag) arr?.unshift?.(specialTag);
            if (tashimedTag) arr?.unshift?.(tashimedTag);
            return arr;
        },
    },
    mounted() {
        this.updateOverflowTag()
        setTimeout(() => {
            this.updateOverflowTag()
        }, 100);
    },
}

</script>

<style lang="scss">

.tags {
    @apply flex overflow-visible text-nowrap relative;
    gap: .5em;
}
.hidden-tag {
    @apply absolute pointer-events-none;
    opacity: 0 !important;
}
.hide-tag-btn {
    text-transform: lowercase !important;
}
.hide-tag-btn:not(:hover) {
    opacity: .95;
}
.hide-tag-btn:not(.hidden-tag) {
    transition-property: opacity;
}

/* ================== Transition Group ================== */

.tags-move,
.tags-enter-active,
.tags-leave-active {
  transition: all 0.5s ease;
}

.tags-enter-from,
.tags-leave-to {
  opacity: 0;
  transform: translateY(-100%);
}

.tags-leave-active {
  position: absolute;
  right: 0;
}

</style>
